export default initHeader = () => {

  const header = document.querySelector("#header");

  if (header) {

    const navigationBtns = document.querySelector(".navigation-buttons")
    const menu1 = document.querySelector(".menu-level-1")
    const secondMenu = document.querySelector("#footer .custom-footer__articles ul")

    if (secondMenu && menu1) {
      secondMenu.classList.add("second-menu")
      menu1.insertAdjacentElement("afterend", secondMenu)
    }

    // if (navigationBtns && menu1) {
    //   menu1.append(navigationBtns)
    // }

  }

};
